export default function Surface({ as: Tag = 'div', className = '', ...props }) {
  const baseClasses =
    'rounded-2xl bg-white ring-1 ring-slate-200/90 shadow-card transition duration-200';

  return <Tag className={`${baseClasses} ${className}`.trim()} {...props} />;
}
